// Petits utilitaires texte partagés par les templates galerie.

// Normalise un champ texte : null/undefined/blanc/'undefined' (chaîne littérale,
// présente dans certaines données de ce projet) -> ''.
export function cleanText(value) {
  const str = (value ?? '').toString().trim();
  return str && str !== 'undefined' ? str : '';
}

// Index zéro-paddé sur 2 chiffres : 1 -> '01', 12 -> '12'.
export function padIndex(n) {
  return String(n).padStart(2, '0');
}
